import { app } from '../../app.module'
app
  // サブカテゴリ入力フォーム
  .directive('editSubCategoryInfo', () => {
    return {
      restrict: 'E',
      template: require('./edit-sub-category-info.pug')(),
    }
  })
